import styled from 'styled-components';

export const Flex1 = styled.div`
  flex: 1;
`;
export const ParentSidebar = styled.div`
  height: 100%;
`;
export const Wrapper = styled.div`
  background: ${({ theme }) => `${theme.palette.primary}`};
  padding: ${({ theme }) => `${theme.spacing.inside.x4}`};
  width: 240px;
  height: 100%;
  overflow-y: clip;
`;
